import { costFormater } from '@common-fe/common-fe';
import _ from 'lodash';

const getSplittedMoneyAmount = (value: number, prefix?: string) => {
  const numberValue = _.round(value % 1, 2);
  const formattedValue = Math.abs(numberValue || 0);
  const decimal = formattedValue ? `${formattedValue.toFixed(2)}`.substring(1) : '.00';
  const newValue = costFormater(value, {
    prefix: prefix || '$',
    isPrecision: false,
  });
  return {
    decimal,
    value: newValue,
  };
};

export default getSplittedMoneyAmount;
